import { AppThunk } from '../../types';
import {
  setCancellationRequestAction,
  setUpdateCancellationRequestErrorAction,
  setUpdateCancellationRequestFetchStatusAction,
} from './reducer';
import { createFetchedSuccess, createFetchedWithError, createFetchInProgress } from 'types/rest/IFetchStatus';
import { eCancellationRequestStatus } from '../../../ui-toolkit/orders/interfaces/eCancellationRequestStatus';
import {
  cancelOrderByIDAsync,
  updateCancellationRequestAsync,
} from '../../../ui-toolkit/orders/methods/cancelOrderAPI';

export const cancelOrderAsync =
  (orderId: string, reason?: string): AppThunk =>
  async (dispatch, getState) => {
    try {
      dispatch(setUpdateCancellationRequestErrorAction(null));
      dispatch(setUpdateCancellationRequestFetchStatusAction(createFetchInProgress()));
      const cancellationRequest = await cancelOrderByIDAsync(orderId, reason || '');
      dispatch(setCancellationRequestAction(cancellationRequest));
      dispatch(setUpdateCancellationRequestFetchStatusAction(createFetchedSuccess()));
    } catch (e: any) {
      dispatch(setUpdateCancellationRequestFetchStatusAction(createFetchedWithError()));
      dispatch(setUpdateCancellationRequestErrorAction(e));
      throw e;
    }
  };

export const updateOrderCancellationRequestAsync =
  (orderId: string, requestId: string, type: eCancellationRequestStatus, reason?: string): AppThunk =>
  async (dispatch, getState) => {
    try {
      dispatch(setUpdateCancellationRequestErrorAction(null));
      dispatch(setUpdateCancellationRequestFetchStatusAction(createFetchInProgress()));
      const cancellationRequest = await updateCancellationRequestAsync(orderId, requestId, type, reason || '');
      dispatch(setCancellationRequestAction(cancellationRequest));
      dispatch(setUpdateCancellationRequestFetchStatusAction(createFetchedSuccess()));
    } catch (e: any) {
      dispatch(setUpdateCancellationRequestFetchStatusAction(createFetchedWithError()));
      dispatch(setUpdateCancellationRequestErrorAction(e));
      throw e;
    }
  };
